import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    deleteProgram,
    deleteProgramVariables,
} from "./__graphql-types__/deleteProgram.ts";

const DELETE_PROGRAM_MUTATION: GqlOperation<
    deleteProgram,
    deleteProgramVariables
> = gqlOp(gql`
    mutation deleteProgram($programID: ID!) {
        deleteProgram(programID: $programID) {
            error {
                code
                debugMessage
            }
        }
    }
`);

// Delete a program
export async function deleteProgramByID(
    gqlFetch: GqlFetchFn,
    programID: string,
): Promise<void> {
    try {
        const data = await gqlFetch(DELETE_PROGRAM_MUTATION, {
            variables: {programID},
        });

        if (data?.deleteProgram?.error) {
            throw new KAError(
                "deleteProgram returned an error",
                Errors.Internal,
                {
                    cause: JSON.stringify(data?.deleteProgram?.error),
                },
            );
        }
    } catch (e: any) {
        throw new KAError("Error deleting program", Errors.Internal, {
            cause: e,
        });
    }
}
